import React from 'react';
import './style.css';

const DataPanel = ({ data, title, dataPercent }) => {

  return(
    <div className="data-panel-email">
      <div className="data-panel-parent-email">
        { data !== null || data !== undefined ? (
          <div>
            <div className="data-panel-value-email">{ data }</div>
            <div className="data-panel-value-email-percent">{ dataPercent }</div>
            <div className="data-panel-title-email">{ title }</div>
          </div>
        ) : (
          <div>
            <div className="data-panel-value-email">Loading...</div>
            <div className="data-panel-title-email">{ title }</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataPanel;
